var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4629 2.4624C3.62346 1.30186 5.22842 0.583008 7.00016 0.583008C8.7719 0.583008 10.3769 1.30186 11.5374 2.4624L11.1249 2.87488L11.5374 2.46241C12.698 3.62297 13.4168 5.22793 13.4168 6.99968C13.4168 8.77142 12.698 10.3764 11.5374 11.5369C10.3769 12.6975 8.7719 13.4163 7.00016 13.4163C5.22842 13.4163 3.62346 12.6975 2.4629 11.5369L2.87537 11.1245L2.46289 11.5369C1.30235 10.3764 0.583496 8.77141 0.583496 6.99968C0.583496 5.22793 1.30235 3.62297 2.46289 2.46241L2.4629 2.4624ZM7.00016 1.74967C5.55027 1.74967 4.23857 2.33666 3.28785 3.28737C2.33714 4.23809 1.75016 5.54978 1.75016 6.99968C1.75016 8.44957 2.33715 9.76127 3.28785 10.712C4.23857 11.6627 5.55027 12.2497 7.00016 12.2497C8.45006 12.2497 9.76176 11.6627 10.7125 10.712C11.6632 9.76127 12.2502 8.44957 12.2502 6.99968C12.2502 5.54978 11.6632 4.23808 10.7125 3.28736C9.76176 2.33666 8.45006 1.74967 7.00016 1.74967Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6665 5.43197C4.6665 4.1433 5.71118 3.09863 6.99984 3.09863C8.2885 3.09863 9.33317 4.1433 9.33317 5.43197C9.33317 6.5192 8.58955 7.43276 7.58317 7.69179V8.34863C7.58317 8.6708 7.322 8.93197 6.99984 8.93197C6.67767 8.93197 6.4165 8.6708 6.4165 8.34863V7.18197C6.4165 6.8598 6.67767 6.59863 6.99984 6.59863C7.64417 6.59863 8.1665 6.0763 8.1665 5.43197C8.1665 4.78764 7.64417 4.2653 6.99984 4.2653C6.35551 4.2653 5.83317 4.78764 5.83317 5.43197C5.83317 5.75413 5.572 6.0153 5.24984 6.0153C4.92767 6.0153 4.6665 5.75413 4.6665 5.43197Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00016 10.974C7.40287 10.974 7.72933 10.6475 7.72933 10.2448C7.72933 9.84209 7.40287 9.51562 7.00016 9.51562C6.59746 9.51562 6.271 9.84209 6.271 10.2448C6.271 10.6475 6.59746 10.974 7.00016 10.974Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.eb5ea9999c53c5297bde41ea18004996.svg";
export { ForwardRef as ReactComponent };